import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule } from '@pos-app/core-ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';

import { ResourcesComponent } from './resources.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, CoreUiModule, NgSelectModule, MatDialogModule],
  declarations: [ResourcesComponent],
  exports: [ResourcesComponent],
})
export class ResourcesModule {}
